import permissions from '@/constants/permissions'

const DreamDrawing = () => import('@/views/document/DreamDrawing.vue')
export default {
  path: 'rysunek-marzenia',
  name: 'DreamDrawing',
  component: DreamDrawing,
  meta: {
    requireAuth: true,
    permission: [permissions.documentView, permissions.assignedDocumentView]
  }
}
